var React = require('react');

function B1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"B1"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("path",{"d":"M18.37,0v0L0,1.11,2.3,41.49l18.38-1v0h0A20.22,20.22,0,0,0,18.37,0","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("path",{"d":"M24.21,31v0H2V79.82H24.21l0,0h0a24.42,24.42,0,0,0,0-48.83","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

B1.defaultProps = {"viewBox":"0 0 48.63 79.82"};

module.exports = B1;

B1.default = B1;
